<template>
  <div class="verify-page">
    <div class="page-top">
      <img
        src="/static/image/nav_chevron_back.bb0f0ac706614ab578365b31d203927a.png"
        alt=""
        class="back-btn"
        @click="$router.back()"
      />
      实名认证
    </div>

    <div class="page-body">
      <section class="hero-card">
        <div class="hero-icon">🎁</div>
        <div class="hero-title">做任务，领福利</div>
        <div class="hero-sub">填写真实信息，完成邮箱验证码后提交人工审核</div>
      </section>

      <section v-if="status !== 0" class="status-card" :class="'status-' + status">
        <div class="status-title">{{ statusText }}</div>
        <div class="status-row">姓名：{{ form.realname || '-' }}</div>
        <div class="status-row">邮箱：{{ form.email || '-' }}</div>
        <div class="status-row" v-if="verified && !mailBound">邮箱状态：待绑定</div>
        <div class="status-row" v-if="status === 3 && reviewRemark">备注：{{ reviewRemark }}</div>
      </section>

      <section class="form-card">
        <div class="section-title">基础信息</div>
        <label class="field">
          <span>真实姓名</span>
          <input v-model.trim="form.realname" type="text" placeholder="请输入真实姓名" :disabled="identityLocked" />
        </label>
        <label class="field">
          <span>邮箱地址</span>
          <input v-model.trim="form.email" type="email" placeholder="请输入邮箱地址" :disabled="emailLocked" />
        </label>
        <label v-if="showEmailCodeField" class="field code-field">
          <span>邮箱验证码</span>
          <div class="code-box">
            <input v-model.trim="form.email_code" type="text" maxlength="6" placeholder="请输入验证码" :disabled="emailLocked" />
            <button type="button" class="code-btn" :disabled="codeSending || emailLocked" @click="sendCode">
              {{ codeSending ? '发送中...' : codeLabel }}
            </button>
          </div>
        </label>
      </section>

      <section class="form-card">
        <div class="section-title">提现账号绑定</div>
        <div class="binding-tip">实名信息提交后即可进入绑定页，审核中或未通过也可以绑定；支付宝需要上传收款码。</div>
        <button class="link-btn" type="button" @click="goPayoutBinding">去绑定提现账号</button>
      </section>

      <button class="submit-btn" type="button" :disabled="submitLocked" @click="submit">
        {{ submitting ? '提交中...' : submitLabel }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'realnameAuth',
  data() {
    return {
      status: 0,
      statusText: '未提交',
      reviewRemark: '',
      verified: false,
      submitting: false,
      codeSending: false,
      codeLabel: '获取验证码',
      countDown: 0,
      codeTimer: null,
      activeBindingType: 'bank',
      mailVerifiedAt: '',
      form: {
        realname: '',
        email: '',
        email_code: ''
      },
      bindingForm: {
        bank: { bank_name: '', account_no: '' },
        alipay: { account_no: '' },
        usdt: { bank_name: 'TRC20', account_no: '' }
      },
      existingBindings: {
        bank: null,
        alipay: null,
        usdt: null
      },
      bindingTabs: [
        { key: 'bank', label: '银行卡' },
        { key: 'alipay', label: '支付宝' },
        { key: 'usdt', label: 'USDT' }
      ]
    };
  },
  computed: {
    mailBound() {
      return !!this.mailVerifiedAt;
    },
    pendingEmailVerification() {
      return this.status === 1 && !this.mailBound;
    },
    identityLocked() {
      return this.submitting || this.mailBound;
    },
    emailLocked() {
      return this.submitting || this.mailBound || (this.status === 1 && !this.pendingEmailVerification);
    },
    showEmailCodeField() {
      return !this.mailBound;
    },
    submitLocked() {
      return this.submitting || (this.status === 1 && !this.pendingEmailVerification) || (this.verified && this.mailBound);
    },
    submitLabel() {
      return this.verified && !this.mailBound ? '确认绑定邮箱' : '提交实名认证';
    }
  },
  created() {
    this.loadStatus();
  },
  methods: {
    notify(type, message) {
      if (this.$parent && typeof this.$parent.showTost === 'function') {
        this.$parent.showTost(type, message);
      }
    },
    loading(on) {
      if (this.$parent && typeof this.$parent.showLoading === 'function' && typeof this.$parent.hideLoading === 'function') {
        if (on) {
          this.$parent.showLoading();
        } else {
          this.$parent.hideLoading();
        }
      }
    },
    lockBinding(type) {
      return !!this.existingBindings[type];
    },
    applyBindings(bindings) {
      this.existingBindings = {
        bank: bindings.bank || null,
        alipay: bindings.alipay || null,
        usdt: bindings.usdt || null
      };
      if (bindings.bank) {
        this.bindingForm.bank.bank_name = bindings.bank.bank_name || this.bindingForm.bank.bank_name;
        this.bindingForm.bank.account_no = bindings.bank.account_no || this.bindingForm.bank.account_no;
      }
      if (bindings.alipay) {
        this.bindingForm.alipay.account_no = bindings.alipay.account_no || this.bindingForm.alipay.account_no;
      }
      if (bindings.usdt) {
        this.bindingForm.usdt.bank_name = bindings.usdt.bank_name || this.bindingForm.usdt.bank_name;
        this.bindingForm.usdt.account_no = bindings.usdt.account_no || this.bindingForm.usdt.account_no;
      }
    },
    goPayoutBinding() {
      if (!this.mailBound) {
        this.notify(0, '请先完成邮箱验证并绑定邮箱，再绑定提现账号');
        return;
      }
      if (!this.form.realname || this.form.realname.length < 2) {
        this.notify(0, '请先填写真实姓名');
        return;
      }
      this.$router.push({ path: '/addBankCard', query: { type: 'alipay' } });
    },
    loadStatus() {
      this.loading(true);
      this.$apiFun.post('/api/realname-status', {}).then(res => {
        this.loading(false);
        if (res.code !== 200) {
          this.notify(0, res.message || '加载失败');
          return;
        }
        const data = res.data || {};
        this.status = Number(data.status || 0);
        this.statusText = data.status_text || '未提交';
        this.reviewRemark = data.review_remark || '';
        this.verified = !!data.verified;
        this.mailVerifiedAt = data.mail_verified_at || '';
        this.form.realname = data.realname || this.form.realname;
        this.form.email = data.email || this.form.email;
        this.applyBindings(data.bindings || {});
      }).catch(() => {
        this.loading(false);
        this.notify(0, '网络异常');
      });
    },
    sendCode() {
      if (this.codeSending || this.countDown > 0) {
        return;
      }
      if (!this.form.email) {
        this.notify(0, '请先填写邮箱地址');
        return;
      }
      this.codeSending = true;
      this.loading(true);
      this.$apiFun.post('/api/send-email-code', {
        email: this.form.email,
        purpose: 'realname'
      }).then(res => {
        this.loading(false);
        this.codeSending = false;
        if (res.code !== 200) {
          this.notify(0, res.message || '验证码发送失败');
          return;
        }
        this.notify(1, res.message || '验证码已发送');
        this.countDown = 60;
        this.codeLabel = '60s';
        if (this.codeTimer) {
          clearInterval(this.codeTimer);
        }
        this.codeTimer = setInterval(() => {
          this.countDown -= 1;
          if (this.countDown <= 0) {
            clearInterval(this.codeTimer);
            this.codeTimer = null;
            this.codeLabel = '获取验证码';
          } else {
            this.codeLabel = `${this.countDown}s`;
          }
        }, 1000);
      }).catch(() => {
        this.loading(false);
        this.codeSending = false;
        this.notify(0, '网络异常');
      });
    },
    buildPayload() {
      const payload = {
        realname: this.form.realname,
        email: this.form.email,
        email_code: this.form.email_code
      };
      if (this.bindingForm.bank.account_no) {
        payload.bank = {
          account_name: this.form.realname,
          bank_name: this.bindingForm.bank.bank_name,
          account_no: this.bindingForm.bank.account_no
        };
      }
      if (this.bindingForm.alipay.account_no) {
        payload.alipay = {
          account_name: this.form.realname,
          account_no: this.bindingForm.alipay.account_no
        };
      }
      if (this.bindingForm.usdt.account_no) {
        payload.usdt = {
          account_name: this.form.realname,
          account_no: this.bindingForm.usdt.account_no,
          bank_name: this.bindingForm.usdt.bank_name
        };
      }
      return payload;
    },
    submit() {
      if (this.submitting) {
        return;
      }
      if (!this.form.realname || this.form.realname.length < 2) {
        this.notify(0, '请填写真实姓名');
        return;
      }
      if (!this.form.email) {
        this.notify(0, '请填写邮箱地址');
        return;
      }
      if (!this.mailBound && !this.form.email_code) {
        this.notify(0, '请输入邮箱验证码');
        return;
      }
      if (this.verified && this.mailBound) {
        this.notify(0, '您已完成实名认证');
        return;
      }

      const payload = this.buildPayload();
      this.submitting = true;
      this.loading(true);
      this.$apiFun.post('/api/realname-submit', payload).then(res => {
        this.loading(false);
        this.submitting = false;
        if (res.code !== 200) {
          this.notify(0, res.message || '提交失败');
          return;
        }
        this.notify(1, res.message || '提交成功');
        // A successful submission always continues to payout binding. The
        // binding page only requires complete identity data and verified email;
        // review state (pending or rejected) is intentionally not a blocker.
        this.$router.replace({ path: '/addBankCard' });
      }).catch(() => {
        this.loading(false);
        this.submitting = false;
        this.notify(0, '网络异常');
      });
    }
  },
  beforeDestroy() {
    if (this.codeTimer) {
      clearInterval(this.codeTimer);
      this.codeTimer = null;
    }
  }
};
</script>

<style scoped>
.verify-page {
  min-height: 100vh;
  background: #f5f7fb;
}

.page-top {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 46px;
  line-height: 46px;
  text-align: center;
  color: #fff;
  font-size: 18px;
  background: url(/img/counter/top-bg.webp) no-repeat #084ccb;
  z-index: 1000;
}

.back-btn {
  width: 16px;
  height: 16px;
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
}

.page-body {
  padding: 62px 14px 28px;
}

.hero-card,
.form-card,
.status-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  margin-bottom: 12px;
}

.hero-card {
  text-align: center;
  background: linear-gradient(180deg, #fff9ef, #fff);
}

.hero-icon {
  font-size: 34px;
  margin-bottom: 6px;
}

.hero-title {
  font-size: 20px;
  font-weight: 700;
  color: #1d2635;
}

.hero-sub {
  margin-top: 6px;
  font-size: 13px;
  color: #7a8499;
}

.section-title {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 10px;
  font-size: 15px;
  font-weight: 700;
  color: #1d2635;
}

.section-title em {
  font-size: 12px;
  font-style: normal;
  color: #8b95a9;
  font-weight: 400;
}

.field {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid #edf1f7;
}

.field:last-child {
  border-bottom: none;
}

.field span {
  width: 78px;
  flex-shrink: 0;
  color: #576277;
  font-size: 14px;
}

.field input,
.field select {
  flex: 1;
  border: 0;
  outline: none;
  background: transparent;
  font-size: 14px;
  color: #1d2635;
}

.code-field {
  align-items: flex-start;
}

.code-box {
  flex: 1;
  display: flex;
  gap: 8px;
  align-items: center;
}

.code-box input {
  min-width: 0;
}

.code-btn {
  width: 110px;
  height: 36px;
  border: 0;
  border-radius: 8px;
  background: #edf3ff;
  color: #1f5bd6;
  font-size: 13px;
}

.tab-row {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

.tab-btn {
  flex: 1;
  height: 36px;
  border: 0;
  border-radius: 8px;
  background: #f3f6fb;
  color: #5c667a;
  font-size: 14px;
}

.tab-btn.active {
  background: #084ccb;
  color: #fff;
}

.binding-tip {
  margin-top: 10px;
  font-size: 12px;
  color: #8b95a9;
  line-height: 1.5;
}

.status-card {
  border-left: 4px solid #084ccb;
}

.status-title {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 8px;
}

.status-row {
  font-size: 14px;
  color: #4d5668;
  line-height: 1.8;
}

.status-1 {
  border-left-color: #f0a020;
}

.status-2 {
  border-left-color: #16a34a;
}

.status-3 {
  border-left-color: #ef4444;
}

.submit-btn {
  width: 100%;
  height: 44px;
  border: 0;
  border-radius: 22px;
  background: linear-gradient(135deg, #2f6df6, #084ccb);
  color: #fff;
  font-size: 16px;
}

.submit-btn:disabled {
  opacity: 0.6;
}

.link-btn {
  width: 100%;
  height: 42px;
  border: 0;
  border-radius: 21px;
  background: linear-gradient(135deg, #f0f4ff, #dfe9ff);
  color: #084ccb;
  font-size: 15px;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/realnameAuth.vue